import React, { createContext, useMemo, useContext, useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import { NOTIFICATION_SOCKET_URL, NOTIFICATION_TYPE } from "../config";
import { userDetailsSelector, userTokenSelector } from "../rdxsga/redux/slices/userSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import logoLight from '../assets/images/logo/beconnectlogo.jpg';
import logoDark from '../assets/images/logo/beconnectlogodark.jpg'
import { useUserAction } from "../rdxsga/hooks/actions/users/useUserActionHook";
import { showSystemNotification } from "../helpers/notification";

const SocketContext = createContext(null);

export const useNotificationSocket = () => {
    const socket = useContext(SocketContext);
    return socket;
};



export const NotificationSocketProvider = (props) => {
    const token = useSelector(userTokenSelector);
    const [socket, setSocket] = useState(null);
    const userDetails = useSelector(userDetailsSelector);
    const userAction = useUserAction();
    const [notification, setNotification] = useState([]);
    const [remainders, setRemainders] = useState([])

    const receiveAllNotification = (res) => {
        if (res?.success && res?.statusCode >= 200 && res?.statusCode <= 300) {
            const data = res.data;
            // setUnseenMessages(data);
            setRemainders([])
            setNotification([])
            data.map((item) => {
                if (item.type == NOTIFICATION_TYPE.REMAINDERS) {
                    setRemainders((prev) => [...prev, item])
                } else {
                    setNotification((prev) => [item, ...prev]);
                }
            })
            console.log({ data })
        } else if (res.statusCode === 401) {
            userAction.logoutUser();
        } else {
            toast.error(res.message ?? "Something Wrong !");
        }
    };

    const loginNotification = (res) => {
        // showSystemNotification({
        //     message: res?.message,
        //     title: "Be-Connect",
        //     url: '/'
        // })


    }


    const receiveNewNotification = (res) => {
        if (res?.success && res?.statusCode >= 200 && res?.statusCode <= 300) {

            const data = res.data;
            if (data.type !== NOTIFICATION_TYPE.REMAINDERS) {
                setNotification((prev) => [data, ...prev]);

                showSystemNotification({
                    title: data?.title,
                    message: data?.message,
                    url: data?.redirect?.url
                })
            } else {
                setRemainders((prev) => [...prev, data])

            }

        } else if (res.statusCode === 401) {
            userAction.logoutUser();
        } else {
            toast.error(res.message ?? "Something Wrong !");
        }

    }





    useEffect(() => {
        //console.log("userDetails", userDetails)
        if (!userDetails?.isAuthenticated) { return }
        const newSocket = socketIOClient(NOTIFICATION_SOCKET_URL, {
            reconnection: true,
            withCredentials: true,
            transports: ["polling", "websocket"],
            query: { userId: userDetails?.user?._id },
            extraHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });


        setSocket(newSocket);

        if (newSocket) {
            newSocket.on('notification', receiveAllNotification);
            newSocket.on('loginNotification', loginNotification);
            newSocket.on('newNotification', receiveNewNotification)
        }

        return () => {
            if (newSocket) {
                newSocket.close();
                newSocket.off('notification', receiveAllNotification);
                newSocket.off('loginNotification', loginNotification);
                newSocket.off('newNotification', receiveNewNotification);
            }

        };
    }, [userDetails]);

    return (
        <SocketContext.Provider value={{
            socket,
            notification,
            remainders
        }}>
            {props.children}
        </SocketContext.Provider>
    );
};
